import {
    createChatBubblesComponent,
    ChatBubbles,
    IChatBubblesItem,
    IChatBubblesProperties,
} from '@vfde-brix/chat-bubbles';

import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix/core';

/**
 * Mount the chat bubbles
 * @param container
 * @param items
 */

const mountChatBubbles = (container: HTMLElement, items): ChatBubbles => {

    const props: IChatBubblesProperties<IChatBubblesItem> = {
        items: items,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createChatBubblesComponent(container, props);

};

export default mountChatBubbles;
